// extracted by mini-css-extract-plugin
export default {"container":"GameInfoMobile__container--3QL","fadeInUp":"GameInfoMobile__fadeInUp--11X"};